<template>
  <div>
    <HomeHeader>
      <div :class="{ noScroll: isNoScroll }">
        <pay
          ref="payModule"
          v-if="!memberShow || showPayPanel"
          @changePay="changePay"
          @login="loginReport"
          @changeRenew="changeRenew"
          @toXieyi="toXieyi"
          @changePayType="changePayType"
          @toAliPay="changePayType"
          @paySuccess="paySuccess"
          no-refresh
        />
        <interests
          @setScrollPosition="setScrollPosition"
          @report="reportInterestsShow"
        />
        <ToTop @to_top="toTop" />
      </div>
      <Redbag @paySuccess="paySuccess" />
    </HomeHeader>
  </div>
</template>
<script>
import PerfMonitorSdk from '@zhfe/perfmonitor-sdk'
import Interests from '@/components/Interests.vue'
import Pay from '@/components/common/CommonPayModule.vue'
import HomeHeader from '@/components/HomeHeader'
import Redbag from '@/components/sendCoupon/activity/Redbag.vue'
import { mapGetters } from 'vuex'
import ToTop from '@/components/common/ToTop'
import homeMixin from '@/mixins/homeMixin.js'
export default {
  name: 'Home',
  components: {
    Pay,
    Interests,
    ToTop,
    HomeHeader,
    Redbag
  },
  mixins: [homeMixin],
  data () {
    return {
      isNoScroll: false,
      showPayPanel: false
    }
  },
  computed: {
    ...mapGetters([
      'isMember',
      'loginStatus',
      'openId',
      'token',
      'userInfo',
      'isContinuous',
    ]),
    memberShow () {
      return !!this.isMember
    },
  },
  watch: {},
  mounted () {
    // 关闭前上报停留时间
    window.onbeforeunload = () => {
      const stay_time = parseInt(
        (new Date().getTime() - performance.timing.fetchStart)
      )
      this.report({ click: 7, stay_time })
      localStorage.setItem('home-stay-time', stay_time)
    }
    /* global buildChannel */
    (buildChannel === '1611' || buildChannel === '1612') && PerfMonitorSdk({
      rate: 1
    })
    // 跳转到滚动条的位置
    this.goToScrollPosition()
    this.$EventBus.$on('showPay', () => {
      this.showPayPanel = true
    })
  },
  methods: {
    paySuccess () {
      this.refresh({
        token: this.token,
        open_id: this.openId,
        webRefresh: 1
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/css/homeMixin.scss';
</style>
